import { Grid, Paper } from "@material-ui/core";
import CustomInput from "components/CustomInput";
import { useGetBusinessUnitsQuery, useGetClientsWithConfigsQuery } from "features/clients/clientConfigSlice";
import { useGetClientsQuery } from "features/clients/clientSlice";
import { setErrors } from "features/loads/loadsStateSlice";
import { selectIsClient, selectUserClientId } from "features/user/userSlice";
import VinDecode from "features/vehicles/VinDecode/VinDecodePopup";
import VinMatching from "features/vehicles/components/VinMatching/VinMatching";
import { useGetFuelTypesQuery, useGetVehicleTypesQuery } from "features/vehicles/vehicleSlice";
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Validator from "services/validator";
import { arrayToObject } from "utils/object-util";
import GroupAssetFormStyles from "./GroupAssetFormStyles";
import SearchForAsset from "../SearchForAsset/SearchForAsset";
import { searchByFieldTypes } from "features/vehicles/consts";
import { vehicle_detail_extended_type, weightClassValues } from "features/vehicles/VehicleDetailExtended/VehicleDetailExtendedTypes";

const useStyles = GroupAssetFormStyles;

const GroupAssetForm = ({ loadGroup, setLoadGroup, clientBUs, setClientBUs, disableAssetDetails, legIndex, resetSearch}) => {

    let { data: vehicleTypes, error: vehicleTypesError, isLoading: isLoadingVehicleTypes, isSuccess: isVehicleTypesSuccess } = useGetVehicleTypesQuery();
    let { data: clientsWithConfigs, error: clientsWithConfigsError, isFetching: isLoadingClientsWithConfigs } = useGetClientsWithConfigsQuery(null);
    let { data: fuelTypes, error: fuelTypesError, isLoading: isLoadingFuelTypes, isSuccess: isSuccessFuelTypes } = useGetFuelTypesQuery();
    let { data: businessUnits, error: businessUnitsError, isLoading: isLoadingbusinessUnits, isSuccess: businessUnitsSuccess } = useGetBusinessUnitsQuery();
    let { data: clients, error: clientError, isLoading: isLoadingClients } = useGetClientsQuery(null);

    vehicleTypes = vehicleTypes || [];
    clientsWithConfigs = clientsWithConfigs || [];
    clients = clients || [];

    const isClient = useSelector(selectIsClient);
    const loggedInUserClientId = useSelector(selectUserClientId);

    const { showMandatoryError, errors } = useSelector(state => state.loadState);

    const dispatch = useDispatch();

    const classes = useStyles();
    const [startTimer, setStartTimer] = useState(false);
    const [decodedData, setDecodedData] = useState({});
    const [colorDecoded, setColorDecoded] = useState(false);
    const [openDecoded, setOpenDecoded] = useState(false);

    let filteredClientConfigIds = clientsWithConfigs?.filter(client => (client.config.transportConfig.useTransport === true)).map(c => c.id);
    let clientAccounts = _.flatten(clients?.map(c => c.clientAccounts));
    let clientAccountsCount = clientAccounts?.length;
    clientAccounts = clientAccounts?.filter(c => filteredClientConfigIds.includes(c.clientId));

    const clientLookup = arrayToObject(clientAccounts, 'id');

    const isLoading = () => isLoadingVehicleTypes || isLoadingClientsWithConfigs;

    const getErrorMessagesForField = {
        'vin': (val) => {
            if (!Validator.validateVin(val)) {
                return "Invalid VIN";
            }
            return false;
        },
        'year': (val) => {
            if (!(val && val > 1980 && val.length <= 4)) {
                return "Invalid year";
            }
            return false;
        },
    }

    const clearErrorForFields = (keys) => {
        const newErrors = { ...errors };
        keys.map(key => {
            if (newErrors[key]) delete newErrors[key];
        })
        dispatch(setErrors(newErrors));
    };

    const onChange = (key, val, groupLevelField) => {
        const errorMessage = getErrorMessagesForField[key] && getErrorMessagesForField[key](val)
        if (errorMessage) {
            dispatch(setErrors({ ...errors, [key]: errorMessage }))
        }
        else {
            clearErrorForFields([key]);
        }
        if (groupLevelField) {
            setLoadGroup({ ...loadGroup, [key]: val });
        } else {
            updateLoad({ [key]: val });
        }
    };

    const updateLoad = (values) => {
        let loads = [...loadGroup?.loads?.map(l => ({ ...l }))];
        if (loads) {
            loads[legIndex] = { ...loads?.[legIndex], ...values }
            setLoadGroup({ ...loadGroup, loads });
        }
    }

    const handleSearchFieldChange = (field, val) => {
        if (typeof val === 'string') {
            onChange(field, val);
            if(val == "") //if we're emptying the search field we also want to empty all other fields
            {
                updateLoad({
                    vin: '',
                    assetId: '',
                    year: '',
                    make: '',
                    model: '',
                    assetTypeId: null,
                    vehicleFuelTypeId: null,
                    vehicleId: null,
                    weightClass: null
                })
            }
            return;
        }
        
        let vehicle = val;
        let value = field == searchByFieldTypes.VIN ? vehicle?.descriptor : vehicle?.assetId;
        onChange(field, value);

        //set vehicle fields on load
        updateLoad({
            vin: vehicle?.descriptor ?? loadGroup?.loads?.[legIndex]?.descriptor,
            assetId: vehicle?.assetId ?? loadGroup?.loads?.[legIndex]?.assetId,
            year: vehicle?.year ?? loadGroup?.loads?.[legIndex]?.year,
            make: vehicle?.make ?? loadGroup?.loads?.[legIndex]?.make,
            model: vehicle?.model ?? loadGroup?.loads?.[legIndex]?.model,
            assetTypeId: vehicle?.vehicleTypeId ?? loadGroup?.loads?.[legIndex]?.vehicleTypeId,
            vehicleFuelTypeId: vehicle?.fuelType ?? vehicle?.vehicleFuelTypeId ?? loadGroup?.loads?.[legIndex]?.vehicleFuelTypeId,
            vehicleId: vehicle?.id ?? loadGroup?.loads?.[legIndex]?.vehicleId,
            weightClass: parseInt(vehicle?.extendedDetails?.find(d => d.vehicleDetailExtendedTypeId == vehicle_detail_extended_type.VehicleWeightClass)?.value) ?? loadGroup?.loads?.[legIndex]?.weightClass
        })
    }

    const populateDecoded = () => {
        setOpenDecoded(false);
        if (decodedData) {
            setColorDecoded(true);
            /* if (decodedData?.vehicleType)
                 setColorDecodedType(true);*/

            updateLoad({
                'year': decodedData?.year,
                'make': decodedData?.make,
                'model': decodedData?.model,
                'weightClass': decodedData?.weightClass
            })
            // setLoadGroup({
            //     ...loadGroup,
            //     'year': decodedData?.year,
            //     'make': decodedData?.make,
            //     'model': decodedData?.model,
            // });
            setTimeout(() => {
                setColorDecoded(false);
            }, 5000);
        }
    }

    useEffect(() => {
        if (startTimer) {
            setTimeout(() => {
                setStartTimer(false);
            }, 4000);
        }
    }, [startTimer]);

    useEffect(() => {
        if (businessUnits?.length) {
            let clientId = loadGroup?.clientId ? loadGroup?.clientId : loggedInUserClientId[0];
            setClientBUs(businessUnits?.filter(b => b.clientId == clientId));
        }
    }, [loadGroup?.clientId, businessUnits, clientsWithConfigs])

    //if user only has access to one account hide dropdown 
    const showClientDropdown = () => {
        if (clientAccountsCount > 1)
            return true;
        return false;
    }

    let form = (
        <Grid direction='row' container >
            <Grid item xs={12}>
                {!loadGroup.id && loadGroup?.loads?.length > 1 &&
                    <div className={classes.input}>
                        <CustomInput
                            elementType='text'
                            value={loadGroup?.groupName}
                            label='Group Name'
                            onChange={(val) => onChange('groupName', val, true)}
                        />
                    </div>}
                <Grid container direction="row">
                    {(!loadGroup.id && showClientDropdown()) &&
                        <Grid item xs={6}>
                            <div className={classes.input}>
                                <CustomInput
                                    id="clientAccountId"
                                    label="Client"
                                    value={loadGroup?.clientAccountId}
                                    elementType="dropdown"
                                    onChange={(val) => {
                                        setLoadGroup({ ...loadGroup, ['clientId']: clientLookup?.[val]?.clientId, ['clientAccountId']: +val });
                                    }}
                                    values={disableAssetDetails ? [{ id: loadGroup?.clientAccountId, name: clientAccounts?.find(c => c.id === loadGroup?.clientAccountId)?.name }] : clientAccounts}
                                    showEmpty
                                    touched
                                    disabled={disableAssetDetails && !!loadGroup?.clientAccountId}
                                />
                            </div>
                        </Grid>
                    }
                    {!!clientBUs?.length &&
                        <Grid item xs={6}>
                            <div className={classes.input}>
                                <CustomInput
                                    id="businessUnit"
                                    label="Business Unit"
                                    value={loadGroup?.businessUnit}
                                    elementType="dropdown"
                                    onChange={val => onChange("businessUnit", +val, true)}
                                    values={clientBUs}
                                    valid={!(showMandatoryError && !loadGroup?.businessUnit)}
                                    showEmpty
                                    required
                                    touched
                                />
                            </div>
                        </Grid>
                    }
                </Grid>
                <Grid container>
                    <Grid item xs={6}>
                        <div className={classes.input}>
                            <Grid container alignItems="center" justifyContent="space-between">
                                <Grid item xs={9}>
                                    <SearchForAsset 
                                        field={searchByFieldTypes.VIN} 
                                        value={loadGroup?.loads?.[legIndex]?.vin} 
                                        clientAccountId={!showClientDropdown() ? clientAccounts[0]?.id : loadGroup?.clientAccountId} 
                                        onChange={handleSearchFieldChange}
                                        resetSearch={resetSearch}
                                    />
                                </Grid>
                                <Grid item >
                                    <VinDecode vin={loadGroup?.loads?.[legIndex]?.vin} setDecodedData={setDecodedData} applyDecode={populateDecoded} openDecoded={openDecoded} setOpenDecoded={setOpenDecoded} />
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>
                    <Grid item xs={6}>
                        <div className={classes.input}>
                            <SearchForAsset 
                                field={searchByFieldTypes.ASSET_ID} 
                                value={loadGroup?.loads?.[legIndex]?.assetId} 
                                clientAccountId={!showClientDropdown() ? clientAccounts[0]?.id : loadGroup?.clientAccountId} 
                                onChange={handleSearchFieldChange}
                                resetSearch={resetSearch}
                            />
                        </div>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={3}>
                        <div className={classes.input}>
                            <CustomInput
                                id="make"
                                label="Vehicle Make"
                                value={loadGroup?.loads?.[legIndex]?.make ?? ""}
                                elementType="input"
                                onChange={val => onChange("make", val)}
                                required
                                valid={!(showMandatoryError && !loadGroup?.loads?.[legIndex]?.make)}
                                touched
                                colorInput={colorDecoded}
                            />
                            {decodedData && <VinMatching decodedData={decodedData.make} editedData={loadGroup?.make} field='make' />}
                        </div>
                    </Grid>
                    <Grid item xs={3}>
                        <div className={classes.input}>
                            <CustomInput
                                id="model"
                                label="Vehicle Model"
                                value={loadGroup?.loads?.[legIndex]?.model ?? ""}
                                elementType="input"
                                onChange={val => onChange("model", val)}
                                required
                                valid={!(showMandatoryError && !loadGroup?.loads?.[legIndex]?.model)}
                                touched
                                colorInput={colorDecoded}
                            />
                            {decodedData && <VinMatching decodedData={decodedData.model} editedData={loadGroup?.model} field='model' />}
                        </div>
                    </Grid>
                    <Grid item xs={3}>
                        <div className={classes.input}>
                            <CustomInput
                                id="year"
                                label="Vehicle Year"
                                value={loadGroup?.loads?.[legIndex]?.year ?? ""}
                                elementType="input"
                                onChange={val => onChange("year", val)}
                                required
                                valid={!errors['year'] && !(showMandatoryError && !loadGroup?.loads?.[legIndex]?.year)}
                                touched
                                numberOnly
                                colorInput={colorDecoded}
                            />
                            {decodedData && <VinMatching decodedData={decodedData.year} editedData={loadGroup?.year} field='year' />}
                        </div>
                    </Grid>
                    <Grid item xs={3}>
                        <div className={classes.input}>
                            <CustomInput
                                id="weightClass"
                                label="Vehicle Weight Class"
                                value={loadGroup?.loads?.[legIndex]?.weightClass ?? ""}
                                elementType="dropdown"
                                values={weightClassValues}
                                onChange={val => onChange("weightClass", val)}
                                required
                                valid={!errors['weightClass'] && !(showMandatoryError && !loadGroup?.loads?.[legIndex]?.weightClass)}
                                touched
                                colorInput={colorDecoded}
                                shrink
                                showEmpty
                            />
                            {decodedData && <VinMatching decodedData={decodedData?.weightClass} editedData={loadGroup?.weightClass} field='weight class' />}
                        </div>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={6}>
                        <div className={classes.input}>
                            <CustomInput
                                id="assetTypeId"
                                label="Vehicle Type"
                                value={loadGroup?.loads?.[legIndex]?.assetTypeId ?? ""}
                                elementType="dropdown"
                                onChange={val => onChange("assetTypeId", +val)}
                                values={vehicleTypes}
                                showEmpty
                                required
                                valid={!(showMandatoryError && !loadGroup?.loads?.[legIndex]?.assetTypeId)}
                                touched
                            />
                        </div>
                    </Grid>
                    <Grid item xs={6}>
                        <div className={classes.input}>
                            <CustomInput
                                id="vehicleFuelTypeId"
                                label="Vehicle Fuel Type"
                                value={loadGroup?.loads?.[legIndex]?.vehicleFuelTypeId ?? ""}
                                elementType="dropdown"
                                onChange={val => onChange("vehicleFuelTypeId", +val)}
                                values={fuelTypes}
                                showEmpty
                                required
                                valid={!(showMandatoryError && !loadGroup?.loads?.[legIndex]?.vehicleFuelTypeId)}
                                touched
                            />
                        </div>
                    </Grid>
                </Grid>
            </Grid>
        </Grid >
    );

    return (
        <Paper className={classes.formContainer}>
            <form id="createLoadForm" className={`${classes.form} ${isLoading() && classes.disabledForm}`}>
                {form}
            </form>
        </Paper>
    );
};

export default GroupAssetForm;
